import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        root:
            'user-avatar flex size-10 items-center justify-center overflow-hidden rounded-xl text-sm ' +
            'bg-[linear-gradient(145deg,var(--avatar-background),color-mix(in_srgb,var(--avatar-background)_80%,transparent))]',
        image: 'h-full w-full object-cover',
        fallbackText: 'select-none font-bold'
    },
    variants: {
        palette: {
            sky: { root: '[--avatar-background:#E0F2FE] text-[#075985]' },
            violet: { root: '[--avatar-background:#EDE9FE] text-[#5B21B6]' },
            green: { root: '[--avatar-background:#DCFCE7] text-(--status-green-deep)' },
            amber: { root: '[--avatar-background:#FEF3C7] text-[#92400E]' },
            rose: { root: '[--avatar-background:#FFE4E6] text-(--token-balance-negative)' },
            indigo: { root: '[--avatar-background:#E0E7FF] text-[#3730A3]' },
            cyan: { root: '[--avatar-background:#ECFEFF] text-[#155E75]' },
            pink: { root: '[--avatar-background:#FCE7F3] text-[#9D174D]' },
            neutral: {
                root: '[--avatar-background:var(--surface-soft-fill)] text-(--text-strong)'
            },
            mint: { root: '[--avatar-background:#F0FDF4] text-(--status-green-deep)' },
            orange: { root: '[--avatar-background:#FFF7ED] text-[#9A3412]' },
            lavender: { root: '[--avatar-background:#EEF2FF] text-[#4338CA]' }
        }
    }
} satisfies ComponentTheme;
